module.exports = __webpack_public_path__ + "static/media/kinternetsecurity.d5ce75d2.png";